

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import {
  ManRadioButtonGroup,
  ManRadioButton,
  ManText
} from '@craft-design-system/core-components-react';
import useGraphRadio from '../../utils/useGraphRadio';
import Shimmer_graph from '../shimmer_graph';
import ifav from './ifav.png';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { CustomTextDisplay } from '../AI';
import { useResetContext} from '../ResetContext';
import { useFilterContext } from '../FilterContext';
import Zoom from '../Zoom'; 
import AverageDisplay from '../ride_analysis_kpi/Average_value';
import DownloadButtonComponent from '../DownloadButtonComponent';
import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';

const Depth_of_discharge = ({ value }) => {
  const [Depth_of_discharge, setDepthOfDischarge] = useState(null);
  const [downloadData, setDownloadData] = useState([]);
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { filterdata } = useFilterContext();
  const { startDate, endDate } = filterdata || {};
  const { resetdata } = useResetContext();
  const radio_query = useGraphRadio();
  const { fetchSegmentedChart } = useSegmentedChartQuery();
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [avg_value, setavg_value] = useState(value.depth_of_discharge[1]['average']);
  const [chartType, setChartType] = useState("Bar");
  const isBarOnly = Depth_of_discharge?.data?.every(trace => trace.type === 'bar');

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <strong>Definition:</strong><br />
        This KPI displays the <strong>daily depth of discharge</strong> in percent. 100% equals the battery capacity of the vehicle. The value can exceed 100% (over the course of the day, the battery can be discharged and charged multiple times).
        <br /><br />
        <strong>Telematic raw data for this KPI:</strong><br />
        TBM3: payloaddecoded_batteryouputenergy_value<br />
        CM4: payload_electricmessagesystem_batteryoutputenergy (BBP), payload_electricmessagesystem_batoutenergycbp (CBP)
        <br /><br />
        <strong>Time series data:</strong><br />
        If multiple vehicles are selected, average values are displayed. Days without data are not taken into account for the calculation.
        <br /><br />
        <strong>Histogram:</strong><br />
        Each bar represents the number of days that fall within a certain range (bin) of depth of discharge values. All daily values since start of data acquisition for the selected vehicle(s) are visualized by default.
        <br /><br />
        <strong>Boxplot:</strong><br />
        The boxplot shows the distribution of daily depth of discharge values for the selected vehicle(s) since start of data acquisition. If multiple vehicles are selected, the boxplot reflects the combined distribution of all their daily values.
        <br /><br />
        • The box represents the middle 50% of values (from the 25th percentile ("q1") to the 75th percentile ("q3")).<br />
        • The line inside the box shows the median (50th percentile).<br />
        • The whiskers extend to show the range of typical values ("min" and "max") and visualize the spread of the data beyond the central box.
      </Popover.Body>
    </Popover>
  );

  const handleSelectChange1 = (event) => {
    set_Radio_values((prevValues) => ({
      ...prevValues,
      [event.detail.name]: event.detail.value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await fetchSegmentedChart({
          vinShort: value.vin_short,
          chartType,
          // startDate: startDate || null,
          // endDate: endDate || null,
          category: resetdata,
          columnname: "Depth_discharge",
        });

        if (chartType === 'Bar') {
          setDepthOfDischarge(JSON.parse(data[0]));
          setDownloadData(JSON.parse(data[2]));
        } else {
          setDepthOfDischarge(JSON.parse(data[0]));
          setDownloadData(JSON.parse(data[1]));
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (!isInitialLoad && chartType && value?.vin_short) {
      fetchData();
    } else {
      setIsInitialLoad(false);
    }
  }, [chartType]);


  useEffect(() => {
    if (radio_buttons_test) {
      setIsLoading(true);

      //console.log(value.vin_short)
      radio_query({vins_short:[value.vin_short],radio_value:radio_buttons_test,columnname:'Depth_discharge',category:resetdata,startDate:startDate,endDate:endDate}).then(data => {
        setDepthOfDischarge(JSON.parse(data['jsonData'][0]));
        // setShowMonthlyText(data['jsonData'][1]['battery_fast_charging']);
        setavg_value(data['jsonData'][1]['average']);
        setDownloadData(JSON.parse(data['jsonData'][2]));
        setIsLoading(false);
      });
    }
  }, [radio_buttons_test, chartType]);
  
  useEffect(() => {
    try {
      setDepthOfDischarge(JSON.parse(value.depth_of_discharge[0]));
      if (value.depth_of_discharge[2]) {
        setDownloadData(JSON.parse(value.depth_of_discharge[2]));
      }
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  return (
  
    <div style={{ padding: '16px' }}>
    {/* Title + Info */}
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
      gap: '8px'
    }}>
      <div style={{
        flex: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '100px'
      }}>
        <ManText
          className="card-title-text"
          variant="component-l"
          as="span"
          size="l"
          style={{ lineHeight: 'normal' }}
        >
         Depth of discharge
        </ManText>
      </div>
      <div style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        flexDirection: "row-reverse"
        // margingtop: 30
      }}>
        {/* <PopoverComponent
          id="charging_time"
          content={tooltipContent}
        /> */}
        <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
          <img className="man-logovv1" src={ifav} alt="info" />
        </OverlayTrigger>
        <Zoom
          chartData={Depth_of_discharge?.data}
          chartLayout={Depth_of_discharge?.layout}
          chartTitle="Efficiency"
        />
        <DownloadButtonComponent
          data={downloadData}
          fileName={`Depth_of_discharge${chartType.toLowerCase()}_${radio_buttons_test?.['Depth of discharge']?.toLowerCase() || 'daily'}.xlsx`}
        />
      </div>
    </div>


      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <div style={{ flexShrink: 0 }}>
          <AverageDisplay averages={avg_value} unit="%" />
        </div>

        <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <ManRadioButtonGroup
            name="Depth of discharge"
            invalid="false"
            onManChange={handleSelectChange1}
            style={{ display: 'flex', gap: '20px' }}
          >
            <ManRadioButton name="Depth of discharge" label="Daily" value="Daily" checked />
            <ManRadioButton name="Depth of discharge" label="Monthly" value="Monthly" />
            <ManRadioButton name="Depth of discharge" label="Yearly" value="Yearly" />
          </ManRadioButtonGroup>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <SegmentedControl
            selected={chartType}
            onChange={(type) => setChartType(type)}
            options={["Bar", "Histogram", "Boxplot"]}
          />
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
        {isLoading ? (
          <Shimmer_graph />
        ) : (
          Depth_of_discharge && (
            <>
              <Plot
              data={Depth_of_discharge.data}
              layout={{
                ...Depth_of_discharge.layout,
                autosize: true,
                responsive: true,
                margin: { t: 10, r: 10, l: 10, b: 160 },
                xaxis: {
                  ...Depth_of_discharge.layout?.xaxis,
                  rangeslider: { visible: false }, // 👈 range slider disabled
                },
              }}
              useResizeHandler={true}
            />

              {/* <CustomTextDisplay
                title="AI | Automotive Intelligence"
                value={showMonthlyText}
                isValueStyled
              /> */}
            </>
          )
        )}
      </div>
    </div>
  );
};

Depth_of_discharge.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    depth_of_discharge: PropTypes.array.isRequired,
  }).isRequired,
};

export default Depth_of_discharge;

